import React from "react";
import HeaderComponent from "../../components/header_component";
import Layout from "../../components/layout";
import NavBar from "../../components/nav_bar_component";
import { Box, ThemeProvider, useTheme } from "@mui/material";
import AnimatedHero from "../../components/animated_hero";
import ImageGrid from "../../components/company_grid";
import Footer from "../../components/footer";
import Location from "./Location";
import VideoLib from "./VideoLib";
import ContactLoc from "./ContactLoc";
const   ParkerStorePage = () => {
  const theme = useTheme();
  const lines = [
    "Siskon Parker",
    "Store",
  ];
  return (
    //

    <div>
      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1 }}>
          <AnimatedHero
          page="parker"
          data="/assets/image/parker_store.png"
            videoSrc="/assets/image/parker-bg.png"
            lines={lines}
            img = {true}
            
          />
        </Box>
      </ThemeProvider>

      {/* Location */}

      <Location />
      <VideoLib/>
      <ContactLoc/>

      <ImageGrid />
      <Footer />
    </div>
  );
};

export default ParkerStorePage;
